type ApiPermission = {
    moduleKey: string;
    actionKey: string;
};

export const normalizePermissions = (
    data: ApiPermission[] = []   
) => {
    const result: Record<string, Record<string, boolean>> = {};

    data.forEach(({ moduleKey, actionKey }) => {
        if (!result[moduleKey]) {
            result[moduleKey] = {};
        }

        result[moduleKey][actionKey.toLowerCase()] = true;
    });

    return result;
};
